<template>
  <div class="home">
    <v-container>
      <v-btn to="/add" color="green" dark style="width: 100%;">
        <v-icon>mdi-plus</v-icon> Aggiungi Prodotto
      </v-btn>

      <v-row>
        <Shoe
          v-for="shoe in shoes"
          :key="shoe._id"
          :shoe="shoe"
          v-on:deleteproduct="deleteProduct"
        />
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Shoe from "../components/Shoe";

export default {
  name: "Home",
  components: {
    Shoe
  },
  data: function() {
    return {
      shoes: []
    };
  },
  methods: {
    deleteProduct: function(id) {
      console.log("Listening event deleteProduct");
      console.log(id);
      this.shoes = this.shoes.filter(el => el._id != id);
    }
  },
  mounted: async function() {
    try {
      let shoes = await fetch(`${process.env.VUE_APP_BACKEND}/shoe/`);
      this.shoes = await shoes.json();
      console.log(this.shoes);
    } catch (e) {
      console.log(e.message);
    }
  }
};
</script>
